import React from "react";
import "./Button.css";

const Button = ({
  children,
  style = undefined,
  onClick,
  className = "",
  type = "button",
  disabled = false,
  ...buttonProps
}) => {
  return (
    <>
      <button
        type={type}
        style={style}
        className={`button ${className}`}
        onClick={onClick}
        disabled={disabled}
        {...buttonProps}
      >
        {children}
      </button>

    </>

  );
};

export default Button;
